module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-new/user-new.component.css
// module id = ./src/app/users/user-new/user-new.component.css
// module chunks = main